import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-386f9fab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-review" }
const _hoisted_2 = { class: "section1 pt-3 px-3" }
const _hoisted_3 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_4 = { class: "text-size-32 text-weight-700 py-1" }
const _hoisted_5 = { class: "canvas-wrapper position-relative" }
const _hoisted_6 = { class: "graph-label" }
const _hoisted_7 = { class: "punctuality d-inline-block position-absolute" }
const _hoisted_8 = { class: "text-size-14 text-weight-500 text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "performance d-inline-block position-absolute" }
const _hoisted_11 = { class: "text-size-14 text-weight-500 text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "greeting d-inline-block position-absolute" }
const _hoisted_14 = { class: "text-size-14 text-weight-500 text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "communication d-inline-block position-absolute" }
const _hoisted_17 = { class: "text-size-14 text-weight-500 text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "skill d-inline-block position-absolute" }
const _hoisted_20 = { class: "text-size-14 text-weight-500 text-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-mild small mt-2" }, "\n          お互いの評価完了後に勤務評価に反映されます\n        ", -1))
const _hoisted_23 = { class: "section2 mt-4" }
const _hoisted_24 = { class: "text-mild text-size-14 text-weight-500 px-3" }
const _hoisted_25 = { class: "thankyou-list border-top border-outline-color mt-2" }
const _hoisted_26 = { class: "text-size-14 text-weight-500" }
const _hoisted_27 = { class: "text-size-14 mt-1 text-break" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_29 = { class: "d-flex justify-content-between text-gray-05 mt-2" }
const _hoisted_30 = { class: "text-gray-05 text-size-14" }

import Chart from "chart.js";
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  onUnmounted,
  ref
} from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import FiveStars from "@/components/molecules/other/FiveStars.vue";
import EvaluationGroup from "@/components/organisms/orders/EvaluationGroup.vue";
import { applicationService } from "@/app/services/ApplicationService";
import { orderService } from "@/app/services/OrderService";
import { accountService } from "@/app/services/AccountService";
import { authStore } from "@/store/auth";
import { Application } from "@/types/order/Application";
import { EvaluationByOffice } from "@/types/order/EvaluationByOffice";
import { TotalAverageEvaluationByOffice } from "@/types/worker/TotalAverageEvaluationByOffice";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";
import { evaluationRound } from "@/utils/evaluationRound";

type EvaluationByOfficeWithApplicationInfo = EvaluationByOffice & {
  applicationInfo: Application;
};

const FETCH_EVALUATION_COUNT = 10;
const THRESHOLD = 50;


export default /*#__PURE__*/_defineComponent({
  __name: 'MyReview',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();
const customRouter = useCustomRouter();

const avgEvaluation = ref<TotalAverageEvaluationByOffice>({
  avgScorePunctuality: 0,
  avgScoreGreeting: 0,
  avgScoreCommunication: 0,
  avgScoreSkill: 0,
  avgScorePerformance: 0,
  count: 0,
  totalAverage: 0
});
// EvaluationByOfficeにapplication情報を追加したオブジェクトの配列
const evaluationList = ref<EvaluationByOfficeWithApplicationInfo[]>([]);
const evaluationCount = ref(0);
const windowHeight = ref(0);
const bodyHeight = ref(0);
// chart.js描画用canvas
const canvas = ref(null);
const hasNext = ref(false);
const isFetching = ref(false);
const initialized = ref(false);

onBeforeMount(async () => {
  try {
    loader.show();
    // アカウント情報を更新
    await accountService.updateUserData();

    await Promise.all([fetchAvgEvaluation(), fetchEvaluation()]);
  } catch (error) {
    await errorModal.showErrorModal(error as Error);
  } finally {
    initialized.value = true;
    loader.hide();
  }
});

onMounted(() => {
  windowHeight.value = window.outerHeight;
  bodyHeight.value = document.body.offsetHeight;
  window.addEventListener("scroll", onScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});

const user = computed(() => authStore.user!);
const filledStarImageSrc = computed(() =>
  require("@/assets/svg/star/filled_star_yellow.svg")
);
const filledStarHalfImageSrc = computed(() =>
  require("@/assets/svg/star/filled_star_half_yellow.svg")
);

async function onClickBack() {
  await customRouter.pushIgnoreError({ name: "Mypage" });
}
// スクロールで下端に近づいたら追加読み込み
async function onScroll() {
  if (isFetching.value || !hasNext.value) return;
  const scrollPos = window.scrollY;
  const bottomDistance = bodyHeight.value - windowHeight.value - scrollPos;
  if (bottomDistance < THRESHOLD) {
    await fetchEvaluation();
  }
}
function toDisplayTime(application: Application) {
  return applicationService.getWorkingTimeText(application);
}
async function fetchAvgEvaluation() {
  avgEvaluation.value = await orderService.fetchTotalEvaluationByOffice(
    user.value.id
  );
  // 平均を取得したらグラフ描画
  drawGraph();
}
async function fetchEvaluation() {
  isFetching.value = true;
  // 評価を取得
  try {
    const response = await orderService.fetchEvaluationByOffice({
      limit: FETCH_EVALUATION_COUNT,
      offset: evaluationList.value.length,
      ordering: "-created_at"
    });
    // 評価に応募データを付与したものを返す
    const results = await mapEvaluationByOfficeWithApplicationInfo(
      response.results
    );
    if (evaluationList.value.length === 0) {
      evaluationList.value = results;
      // 初回のみ件数も更新
      evaluationCount.value = response.count;
    } else {
      evaluationList.value = evaluationList.value.concat(results);
    }
    hasNext.value = !!response.next;
    await nextTick(() => {
      bodyHeight.value = document.body.offsetHeight;
    });
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    isFetching.value = false;
  }
}
async function mapEvaluationByOfficeWithApplicationInfo(
  evaluationList: EvaluationByOffice[]
) {
  // 応募IDのリストから応募データを取得して、応募IDをキーとしたMAPにする
  const applicationIds = evaluationList.map(evaluation => {
    return evaluation.application;
  });
  const {
    results: applications
  } = await applicationService.fetchApplicationListByIds(applicationIds);
  const applicationMap = new Map<number, Application>();
  applications.forEach(application => {
    applicationMap.set(application.id, application);
  });
  // 評価に応募データを紐づけて返す
  return evaluationList.map(evaluation => {
    return {
      ...evaluation,
      applicationInfo: applicationMap.get(evaluation.application)
    } as EvaluationByOfficeWithApplicationInfo;
  });
}
function drawGraph() {
  const data = {
    labels: ["時間", "遂行", "挨拶", "コミュニケーション", "スキル"],
    datasets: [
      {
        data: [
          avgEvaluation.value.avgScorePunctuality,
          avgEvaluation.value.avgScorePerformance,
          avgEvaluation.value.avgScoreGreeting,
          avgEvaluation.value.avgScoreCommunication,
          avgEvaluation.value.avgScoreSkill
        ],
        backgroundColor: "rgba(255, 221, 12, 0.3)",
        borderColor: "rgba(239, 179, 14, 1.0)",
        borderWidth: 1
      }
    ]
  };
  const options = {
    legend: {
      display: false
    },
    scale: {
      pointLabels: {
        display: false
      },
      ticks: {
        beginAtZero: true,
        min: 0,
        max: 5,
        stepSize: 1.25,
        showLabelBackdrop: false,
        callback: () => ""
      }
    }
  } as Chart.ChartOptions;
  new Chart(canvas.value!, {
    type: "radar",
    data,
    options
  });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      勤務評価\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BgWaveCard, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(avgEvaluation.value.count) + "件の評価\n            ", 1),
              _createTextVNode(),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(evaluationRound)(avgEvaluation.value.totalAverage)), 1),
              _createTextVNode(),
              _createVNode(FiveStars, {
                "filled-star-image-src": filledStarImageSrc.value,
                "filled-star-half-image-src": filledStarHalfImageSrc.value,
                value: _unref(evaluationRound)(avgEvaluation.value.totalAverage),
                size: "26"
              }, null, 8, ["filled-star-image-src", "filled-star-half-image-src", "value"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("canvas", {
                ref_key: "canvas",
                ref: canvas,
                width: "190",
                height: "190"
              }, null, 512),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, [
                    _createTextVNode("\n                  時間"),
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(_unref(evaluationRound)(avgEvaluation.value.avgScorePunctuality)), 1)
                  ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, [
                    _createTextVNode("\n                  遂行"),
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(_unref(evaluationRound)(avgEvaluation.value.avgScorePerformance)), 1)
                  ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", _hoisted_14, [
                    _createTextVNode("\n                  挨拶"),
                    _hoisted_15,
                    _createTextVNode(_toDisplayString(_unref(evaluationRound)(avgEvaluation.value.avgScoreGreeting)), 1)
                  ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, [
                    _createTextVNode("\n                  コミュニケーション"),
                    _hoisted_18,
                    _createTextVNode(_toDisplayString(_unref(evaluationRound)(avgEvaluation.value.avgScoreCommunication)), 1)
                  ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, [
                    _createTextVNode("\n                  スキル"),
                    _hoisted_21,
                    _createTextVNode(_toDisplayString(_unref(evaluationRound)(avgEvaluation.value.avgScoreSkill)), 1)
                  ])
                ])
              ])
            ])
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _hoisted_22
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("h3", _hoisted_24, "\n          Thank you message (" + _toDisplayString(evaluationCount.value) + ")\n        ", 1),
        _createTextVNode(),
        _createElementVNode("ul", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evaluationList.value, (evaluation) => {
            return (_openBlock(), _createElementBlock("li", {
              key: evaluation.id,
              class: "bg-white border-bottom border-outline-color"
            }, [
              _createVNode(_component_RouterLink, {
                to: {
                name: 'ApplicationsDetail',
                params: { applicationId: evaluation.applicationInfo.id }
              },
                class: "d-block p-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", _hoisted_26, _toDisplayString(evaluation.applicationInfo.order.office.name), 1),
                  _createTextVNode(),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(evaluation.thankYouMessage), 1),
                  _createTextVNode(),
                  _hoisted_28,
                  _createTextVNode(),
                  _createVNode(EvaluationGroup, {
                    evaluation: evaluation,
                    class: "mt-2"
                  }, null, 8, ["evaluation"]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(toDisplayTime(evaluation.applicationInfo)), 1),
                    _createTextVNode(),
                    _createVNode(FeatherIcon, {
                      icon: "chevron-right",
                      size: "1x"
                    })
                  ])
                ], undefined, true),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, initialized.value]
    ])
  ]))
}
}

})